module.exports = __webpack_public_path__ + "img/iconsProfile.e4adff55.png";